import { forwardRef, React, useImperativeHandle, useRef } from 'react'
import FormCreator from '../../../../components/Forms/FormCreator';

const CorporateMembershipSubscription = forwardRef(({ formData }, ref) => {
  const MembershipSubscriptionFormRef = useRef();
  useImperativeHandle(ref, () => ({
    getFormData: () => {
      if (ref?.current) {
        const data = MembershipSubscriptionFormRef.current.getFormData();
        return data;
      }
      return null;
    }
  }));
  return (
    <div className="form-field-sec">
      <div className="row gx-5">
        <FormCreator
          ref={MembershipSubscriptionFormRef}
          {...formData}
        ></FormCreator>
      </div>
    </div>

  )
}
)
export default CorporateMembershipSubscription